import Action from '../Action';
import { useEffect, useState } from 'react';
import LoadSimple from '../LoadSimple';
import { capitalizeFirstLetter } from '../../utils/utils';
import './styles/modalHistoric.css';
import './styles/modalEvents.css';
import { lang } from '../generales/traduction';
import AlertsByHost from './Events/AlertsByHost';
import Modal from 'react-modal';
import ActionModal from '../ActionModal';
import ConsolaHost from '../ConsolaHost';
import ModalHistoric from './ModalHistoric';
import { useFetch } from '../../hooks/useFetch';
import { permisos_codigo_id } from '../generales/GroupsId';
import MenuResetModal from '../modals-monitoreo/ResetModal';
import InfoValidateReset from '../modals-monitoreo/InfoValidateReset';
import ReactDOM from 'react-dom';
import { useRef } from 'react';

const pingModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#363636',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px',
  },
};

const ModalEvents = ({
  languaje, dataCriticalities, dataAgencies, deviceId,
  hostSelected, server, mode, handleShowPopup, closeAddHostModal, dataServers, userPermissions
}) => {
  const [listSelected, setListSelected] = useState(3);
  const [listActions, setListActions] = useState({ data: [], loading: true, error: null });
  const [actionSelected, setActionSelected] = useState({});
  const [pingModalOpen, setPingModalOpen] = useState(false);
  const [statusPing, setStatusPing] = useState(false);
  const [consoleActive, setConsoleActive] = useState(false);

  // RESET LOGIC
  const alias_reset = useFetch('cassia/technologies/reset_alias', '', '', 'GET', server);
  const [resetModalOpen, setResetModalOpen] = useState(false);
  function openResetModal() { setResetModalOpen(true); }
  function closeResetModal() { setResetModalOpen(false); }

  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const handleMouseEnter = () => {
    const tooltipW = 300;
    if (!triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();
    let left = rect.left + window.scrollX + rect.width / 2;

    if (rect.left + tooltipW / 2 > window.innerWidth) {
      left = rect.right + window.scrollX - tooltipW;
    }
    if (left - tooltipW / 2 < 0) {
      left = tooltipW / 2 + 8;
    }

    setPosition({
      top: rect.top + window.scrollY - 8,
      left: left,
    });
    setVisible(true);
  };

  const uPerms = userPermissions || [];
  const hasResetPerm = true //uPerms.some(o => o.permission_id === permisos_codigo_id['RESET']);

  const hadleChangeList = (e) => setListSelected(e);

  function search_actions() {
    setListActions({ data: [], loading: true, error: listActions.error });
    const fetchData = async () => {
      try {
        const response = await fetch(
          server.url + '/api/v1/zabbix/hosts/actions/' + hostSelected.ip,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
          }
        );
        if (response.ok) {
          const response_data = await response.json();
          setListActions({ data: response_data.data, loading: false, error: listActions.error });
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        setListActions({ data: listActions.data, loading: listActions.loading, error: error });
      }
    };
    fetchData();
  }

  useEffect(() => { search_actions(); }, []);

  function openPingModal() { setPingModalOpen(true); }
  function closePingModal() { setPingModalOpen(false); }

  const handlePingClick = (data) => {
    setActionSelected(data);
    setStatusPing(true);
    openPingModal();
  };

  const actionConsole = () => setConsoleActive(!consoleActive);

  const tabs = [
    { id: 3, label: 'Histórico' },
    { id: 2, label: capitalizeFirstLetter(lang[languaje]['eventos']) },
    { id: 1, label: capitalizeFirstLetter(lang[languaje]['acciones']) },
  ];

  // ─── Detect ping metric for header status ───
  const pingMetric = hostSelected.metrics
    ? hostSelected.metrics.find((m) => /ping/i.test(m.name))
    : null;

  // Derive status from ping metric value
  const getPingStatus = () => {
    if (!pingMetric) return null; // no ping found → don't show status
    const val = String(pingMetric.value || '').toLowerCase();
    if (val === 'conectado' || val === '1' || val === 'up' || val === 'online') {
      return { online: true, label: 'Conectado' };
    }
    return { online: false, label: 'Desconectado' };
  };
  const deviceStatus = getPingStatus();

  return (
    <>
      <div className="modal-GS-content">
        {consoleActive ? (
          <ConsolaHost server={server} ip={hostSelected.ip} actionConsole={actionConsole} hostId={hostSelected.hostId} />
        ) : (
          <div className="me-modal-container">
            {/* ═══ PREMIUM HEADER ═══ */}
            <div className="me-header">
              <div className="me-header-left">
                <div className="me-device-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                  </svg>
                </div>
                <div className="me-device-info">
                  <h2 className="me-device-name">{hostSelected.hostname}</h2>
                  <div className="me-device-meta">
                    <span className="me-ip-badge">IP: {hostSelected.ip}</span>
                    {deviceStatus && (
                      <>
                        <span className="me-dot-sep"></span>
                        <span className={deviceStatus.online ? 'me-status-online' : 'me-status-offline'}>
                          <span className={deviceStatus.online ? 'me-pulse-dot' : 'me-pulse-dot-off'}></span>
                          {deviceStatus.label}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="me-header-right">
                <div className="me-tabs">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      className={`me-tab ${listSelected === tab.id ? 'me-tab-active' : ''} ${tab.id === 1 ? 'me-tab-animated-actions' : ''}`}
                      onClick={() => hadleChangeList(tab.id)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
                <button className="me-close-btn" onClick={closeAddHostModal} title="Cerrar">
                  ✕
                </button>
              </div>
            </div>

            {/* ═══ BODY ═══ */}
            <div className="me-body">
              {listSelected === 3 ? (
                <ModalHistoric
                  server={server}
                  handleShowPopup={handleShowPopup}
                  hostSelected={hostSelected}
                  languaje={languaje}
                  mode={mode}
                />
              ) : listSelected === 2 ? (
                <AlertsByHost
                  dataCriticalities={dataCriticalities}
                  dataAgencies={dataAgencies}
                  handleShowPopup={handleShowPopup}
                  hostSelected={hostSelected}
                  languaje={languaje}
                  mode={mode}
                  server={server}
                />
              ) : listSelected === 1 ? (
                <div className="me-actions-content">
                  <div className="me-actions-grid">
                    {listActions.loading || alias_reset.loading ? (
                      <LoadSimple />
                    ) : (
                      <>
                        {alias_reset.data?.data?.some(item => item.alias.trim() === hostSelected.affiliation?.trim()) ? (
                          <div
                            className="me-action-cell"
                            ref={triggerRef}
                            onMouseEnter={() => (!hasResetPerm || !hostSelected.object_id) ? handleMouseEnter() : null}
                            onMouseLeave={() => (!hasResetPerm || !hostSelected.object_id) ? setVisible(false) : null}
                          >
                            <Action
                              origen="Azul"
                              disabled={!hasResetPerm || !hostSelected.object_id}
                              titulo={'Reset '}
                              action={() => openResetModal()}
                            />
                          </div>
                        ) : null}

                        {listActions.data.actions && (() => {
                          const terminalAction = listActions.data.actions.find(
                            (e) => e.action_id === 21 || (e.name && e.name.toLowerCase().includes('terminal'))
                          );
                          const otherActions = listActions.data.actions.filter((e) => e !== terminalAction);

                          return (
                            <>
                              {terminalAction && (
                                <div className="me-action-cell-primary">
                                  <div className="me-terminal-btn-wrapper">
                                    <Action
                                      origen="Azul"
                                      disabled={false}
                                      titulo={terminalAction.name}
                                      action={() => actionConsole()}
                                    />
                                  </div>
                                </div>
                              )}
                              {otherActions.map((elemento, indice) => (
                                <div className="me-action-cell" key={indice}>
                                  <Action
                                    origen="Azul"
                                    disabled={false}
                                    titulo={elemento.name}
                                    action={
                                      elemento.action_id === 21
                                        ? () => actionConsole()
                                        : () => handlePingClick(elemento)
                                    }
                                  />
                                </div>
                              ))}
                            </>
                          );
                        })()}
                      </>
                    )}
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        )}
      </div>

      <Modal
        isOpen={pingModalOpen}
        onRequestClose={closePingModal}
        style={pingModalStyles}
        contentLabel="Action Modal"
      >
        <ActionModal
          mode={mode}
          handleShowPopup={handleShowPopup}
          ip={hostSelected.ip}
          actionSelected={actionSelected}
          server={server}
          isOpen={pingModalOpen}
          statusPing={statusPing}
          closeActionModal={closePingModal}
        />
      </Modal>

      {/* Portal del tooltip RESET */}
      {visible && ReactDOM.createPortal(
        <div
          style={{
            position: 'absolute',
            top: position.top,
            left: position.left,
            transform: 'translate(-50%, -100%)',
            zIndex: 9999,
          }}
          onMouseEnter={() => setVisible(true)}
          onMouseLeave={() => setVisible(false)}
        >
          <InfoValidateReset
            hasPermission={hasResetPerm}
            hasConfig={hostSelected.object_id}
          />
        </div>,
        document.body
      )}

      <Modal
        isOpen={resetModalOpen}
        onRequestClose={closeResetModal}
        style={{
          content: {
            top: '50%',
            left: '50%',
            background: 'transparent',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '70%',
            height: '80%',
            padding: '20px',
            border: 'unset'
          }
        }}
        contentLabel="Reset Modal"
      >
        <MenuResetModal
          handleShowPopup={handleShowPopup}
          props={{ handleShowPopup: handleShowPopup, server: server, languaje: languaje, data: { ip: hostSelected.ip, affiliation: hostSelected.affiliation } }}
          isOpen={resetModalOpen}
          data={hostSelected}
          statusPing={statusPing}
          closeActionModal={closeResetModal}
        />
      </Modal>
    </>
  );
};

export default ModalEvents;